import React, { useState, useContext } from 'react'
import axios from 'axios'
import '../styles/Tournament.css'
import config from '../config'
import { AuthContext } from '../context/AuthContext'

export default function CreateTournamentModal({ leaderboardId, onClose }) {
  const {
    userToken,
    isAuthenticated,
    isAdmin,
    userId,
    username: currentUsername,
  } = useContext(AuthContext)
  const [tournamentDetails, setTournamentDetails] = useState({
    title: '',
    startDate: '',
    endDate: '',
    category: '',
    details: '',
    status: 'Active',
  })

  const handleChange = (e) => {
    setTournamentDetails({
      ...tournamentDetails,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async () => {
    if (
      !tournamentDetails.title ||
      !tournamentDetails.startDate ||
      !tournamentDetails.endDate ||
      !tournamentDetails.category ||
      !tournamentDetails.details
    ) {
      alert('Please fill out all fields.')
      return
    }

    try {
      await axios.post(
        `${config.backendUrl}/api/tournaments`,
        {
          ...tournamentDetails,
          leaderboardId,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      )
      alert('Tournament created successfully!')
      onClose()
    } catch (error) {
      console.error('Error creating tournament:', error)
      alert('Failed to create tournament.')
    }
  }

  return (
    <div className="popup-container tournament-popup">
      <div className="tournament-header-container">
        <h1 className="tournament-header">Create tournament</h1>
        <button
          className="CreatePostFeedButton tournament-close-button"
          onClick={onClose}
        >
          Close
        </button>
      </div>
      <div className="tournament-row">
        <button
          className="CreatePostFeedButton tournament-close-button"
          onClick={onClose}
        >
          Back
        </button>
      </div>
      <div className="tournament-col">
        <label className="tournament-details-content">Title:</label>
        <textarea
          name="title"
          value={tournamentDetails.title}
          onChange={handleChange}
          className="tournament-titleInput"
        ></textarea>
      </div>
      <div className="tournament-row">
        <div className="tournament-col">
          <label className="tournament-label">Category:</label>
          <div className="tournament-category">
            <select
              className="tournament-input"
              name="category"
              value={tournamentDetails.category}
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              <option value="Individual">Individual</option>
              <option value="Group">Group</option>
            </select>
          </div>
        </div>
        <div className="tournament-col">
          <label className="tournament-label">Start date:</label>
          <input
            type="date"
            name="startDate"
            min={new Date().toISOString().split('T')[0]} // Restricts past dates
            value={tournamentDetails.startDate}
            onChange={handleChange}
            className="tournament-input"
          />
        </div>
        <div className="tournament-col">
          <label className="tournament-label">End date:</label>
          <input
            type="date"
            name="endDate"
            min={tournamentDetails.startDate} // Ensures endDate is not before startDate
            value={tournamentDetails.endDate}
            onChange={handleChange}
            className="tournament-input"
          />
        </div>
      </div>
      <div className="tournament-col">
        <label className="tournament-label">Details:</label>
        <textarea
          name="details"
          value={tournamentDetails.details}
          onChange={handleChange}
          className="tournament-textarea"
        ></textarea>
      </div>
      <div className="tournament-button-wrapper">
        <button
          className="CreatePostFeedButton goldButton"
          onClick={handleSubmit}
        >
          Create tournament
        </button>
      </div>
    </div>
  )
}
